module.exports = __webpack_public_path__ + "img/cavalier-challenge-gameplay_a20c81dd89430847f81b4de82255b5c8.gif";


//////////////////
// WEBPACK FOOTER
// ./client/img/cavalier-challenge-gameplay.gif
// module id = 264
// module chunks = 0